import { useEffect, useState } from 'react';

const DISMISS_KEY = 'sukalpa-pwa-install-dismissed';

export default function InstallPwaPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onBeforeInstallPrompt = (event) => {
      event.preventDefault();
      if (localStorage.getItem(DISMISS_KEY) === 'true') return;
      setDeferredPrompt(event);
      setVisible(true);
    };

    const onAppInstalled = () => {
      setVisible(false);
      setDeferredPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt);
    window.addEventListener('appinstalled', onAppInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt);
      window.removeEventListener('appinstalled', onAppInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setVisible(false);
  };

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9998] w-[92%] max-w-md animate-fadeIn">
      <div className="relative flex items-center gap-4 bg-white rounded-2xl shadow-2xl border border-gray-100 p-4 sm:p-5">
        <button
          onClick={handleDismiss}
          aria-label="Dismiss install prompt"
          className="absolute top-2 right-2 w-6 h-6 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-700 hover:bg-gray-100 text-sm transition"
        >
          &times;
        </button>

        <img
          src="/release/sukalpa-logo.jpeg"
          alt="Sukalpa Logo"
          className="w-14 h-14 rounded-xl object-cover shadow-md flex-shrink-0"
        />

        <div className="flex-1 min-w-0">
          <p className="font-semibold text-gray-900 text-sm sm:text-base">Install Sukalpa App</p>
          <p className="text-xs sm:text-sm text-gray-500 truncate">Quick access, right from your home screen.</p>
        </div>

        <button
          onClick={handleInstall}
          className="flex-shrink-0 px-4 py-2 rounded-full bg-[#7a1f1f] hover:bg-[#601818] text-white text-sm font-semibold shadow transition"
        >
          Install
        </button>
      </div>
    </div>
  );
}
